import classNames from 'classnames';
import React from 'react';
import { Logo, Button, ArrowLeftLine } from '@lana-ui/common';
import './headerLogin.scss';
import useObtenerLogoHeader from '../../../../../Hooks/useObtenerLogoHeader';

const HeaderLogin = ({
    showArrowBack,
    leftContent,
    rightContent,
    centerContent,
    className,
    black,
    ...r
}) => {
    const classes = classNames('lgn-header-wrapper', className, {
        '--black': black,
    });
    const location = window.location.pathname;
    const logoLN = useObtenerLogoHeader();

    return (
        <div className={classes}>
            <header className="lgn-header" {...r}>
                <div className="--left">
                    {leftContent
                        ? leftContent
                        : location &&
                        showArrowBack && (
                            <Button
                                onClick={() => showArrowBack()}
                                className="back-icon"
                                icon="arrowLeftLine"
                            />
                        )}
                </div>

                <div className="--center">
                    {centerContent ? (
                        centerContent
                    ) : (
                        <Logo
                            name={!black ? logoLN : 'club-lanacion'}
                            href="https://www.lanacion.com.ar"                            
                            title="Ir a LA NACION"
                        />
                    )}
                </div>

                <div className="--right">{rightContent}</div>
            </header>
        </div>
    );
};

export default HeaderLogin;
